export default {
  getContractItem: (state) => state.contractItem,
};
